import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../Link/Link';
import Loader from '../../Common/Loader/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/messages';
import { uploadProfileImage } from '../../../actions/siteadmin/uploadProfileImage';
import { api, profilePhotouploadDir } from '../../../config';

import s from './EditUserForm.css';
import bt from '../../../components/commonStyle.css';

export class EditUserForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			countryCode: 'US',
			country: '+1',
		};
	}

	static defaultProps = {
		loading: false
	};

	success = async (fileName) => {
		const { change, uploadProfileImage, id, picture } = this.props;
		await change('picture', fileName);
		uploadProfileImage(id, fileName, picture)
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, disabled, maxLength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<label className={bt.labelText} >{label}</label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} disabled={disabled} maxLength={maxLength} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}
	renderFieldPhoneNumber = ({ input, label, writeOnce, type, meta: { touched, error }, fieldClass, placeholder, disabled }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<Form.Control {...input} readOnly={writeOnce} placeholder={placeholder} type={type} className={bt.formControlInput} disabled={disabled} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}
	handleChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	}
	handleCountryChange = (e, selectedData) => {
		this.setState({
			country: selectedData.dialCode,
			countryCode: selectedData.countryCode
		});
	}
	componentDidMount() {
		const { initialValues } = this.props;
		if (initialValues && initialValues?.country && initialValues?.phoneCountryCode) {
			this.setState({
				countryCode: initialValues?.phoneCountryCode,
				country: initialValues?.country
			});
		}
	}
	render() {
		const { handleSubmit, picture, loading, submitting, profileImageLoader, currency } = this.props
		const { formatMessage } = this.props.intl;
		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<div className={s.responsiveNoPadding}>
					<Card className={s.card}>
						<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
							<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(messages.editUser)}</h1>
							<div className={cx(bt.space3, s.singalCard, s.marbtm14)}>
								<Form.Group className={s.formGroup} >
									<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
										<div className={'commonFilepicker'}>
											<ImageUploadComponent
												className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
												subTextClass={cx(s.subText, 'textWhiteTwo')}
												subText={formatMessage(messages.maximumUploadSizeLabel)}
												defaultMessage={formatMessage(messages.chooseFile)}
												postUrl={api.apiEndpoint + '/uploadProfileImage'}
												loaderName={'profileImageLoader'}
												loader={profileImageLoader}
												fieldName={'picture'}
												formName={'EditUserForm'}
												imageSrc={picture ? api.apiEndpoint + profilePhotouploadDir + 'medium_' + picture : null}
												label={formatMessage(messages.profilePicture)}
												handleDropzone={this.success}
												labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
											/>
										</div>
									</div>
								</Form.Group>
							</div>
							<Row>
								<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="firstName"
												type="text"
												placeholder={formatMessage(messages.firstName)}
												component={this.renderField}
												label={formatMessage(messages.firstName)}
												labelClass={bt.labelText}
												fieldClass={bt.formControlInput}
											/>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="lastName"
												type="text"
												placeholder={formatMessage(messages.lastName)}
												component={this.renderField}
												label={formatMessage(messages.lastName)}
												labelClass={bt.labelText}
												fieldClass={bt.formControlInput}
											/>
										</div>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="email"
												type="text"
												component={this.renderField}
												placeholder={formatMessage(messages.email)}
												label={formatMessage(messages.email)}
												labelClass={bt.labelText}
												fieldClass={bt.formControlInput}
												disabled={true}
											/>
										</div>
									</Form.Group>
								</Col>

								<Col lg={6} md={12} sm={12} xs={12} className={cx(s.space2)}>
									<div><label className={bt.labelText} >{formatMessage(messages.phoneNumber)}</label></div>
									<div className={s.countryGrid}>
										<div className={cx(s.displayInlineBlock, 'phoneColor')}>
											<Form.Group className={s.formGroup}>
												<div>
													<Field
														name="phoneDialCode"
														type="text"
														placeholder={formatMessage(messages.phoneDialCode)}
														component={this.renderFieldPhoneNumber}
														labelClass={bt.labelText}
														fieldClass={cx(bt.formControlInput, bt.formControlInputCountryCode)}
														writeOnce={true}
													/>
												</div>
											</Form.Group>
										</div>
										<div className={cx(s.displayInlineBlock, 'phoneNumber')}>
											<Form.Group className={s.formGroup}>
												<div>
													<Field
														name="phoneNumber"
														type="text"
														placeholder={formatMessage(messages.phoneNumber)}
														component={this.renderFieldPhoneNumber}
														labelClass={bt.labelText}
														fieldClass={cx(bt.formControlInput, bt.formControlInputCountry)}
														disabled={true}
													/>
												</div>
											</Form.Group>
										</div>
									</div>
								</Col>
							</Row>
							<Row>
								<Col lg={3} md={6} sm={6} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup} controlId="exampleForm.ControlSelect1">
										<div>
											<label className={bt.labelText} >{formatMessage(messages.banStatus)}</label><br />
											<Field name="isBan" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
												<option value="0">{formatMessage(messages.permit)}</option>
												<option value="1">{formatMessage(messages.ban)}</option>
											</Field>
										</div>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col lg={3} md={6} sm={6} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup} controlId="exampleForm.ControlSelect1">
										<div>
											<label className={bt.labelText}>{formatMessage(messages.preferredCurrency)}</label><br />
											<Field name='preferredCurrency' className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
												{currency && currency?.availableCurrencies.map(item => (
													<option key={item?.id} value={item?.symbol}>{item?.symbol}</option>
												))}
											</Field>
										</div>
									</Form.Group>
								</Col>
							</Row>
							<div className={cx(bt.textAlignRight, bt.spaceTop3, 'textAlignLeftRTL', 'loadingBtnRTL')}>
								<div className={s.displayInlineBlock}>
									<Loader
										type={"button"}
										label={formatMessage(messages.update)}
										show={loading}
										buttonType={'submit'}
										className={cx(bt.btnPrimary)}
										disabled={submitting || loading}
										isSuffix={true}
									/>
								</div>
								<Link to={"/siteadmin/users"} className={cx(s.backBtn, bt.btnSecondary, 'backBtnRTL')}>{formatMessage(messages.goBack)}</Link>
							</div>
						</Form>
					</Card>
				</div>
			</div>
		)
	}
}
EditUserForm = reduxForm({
	form: 'EditUserForm', // a unique name for this form
	validate,
	onSubmit: submit
})(EditUserForm)
const selector = formValueSelector('EditUserForm')
const mapState = state => ({
	id: selector(state, 'id'),
	picture: selector(state, 'picture'),
	loading: state?.loader?.EditUser,
	profileImageLoader: state?.loader?.profileImageLoader,
	currency: state?.currency
})
const mapDispatch = {
	change,
	uploadProfileImage
}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(EditUserForm)));


